import { PositionFillRequestsFilters } from '../types';

export const buildFilter = (searchValue: string, filters?: PositionFillRequestsFilters) => ({
  ...filters,
  ...(searchValue.trim() ? { id: { ct: searchValue.trim() } } : {}),
});
